angular.module('app.controllers').controller('TubesCtrl', ['$scope', 'APIRead2', 'UI'].append(function(self, APIRead2, UI) {
  self.presenterQuery = APIRead2.query({
    entry_type: 'talents',
    exhibitor_id: 819655
  }, function(data) {
    self.top = data.shift();
    return self.presenter = data;
  }, function(response) {
    return UI.notify(false, response.error.data);
  });
  self.slickInit = false;
  return self.slick = {
    infinite: true,
    dots: true,
    arrows: true,
    dotsClass: 'slider-dots m-0',
    appendDots: '.slider-tube-dots',
    customPaging: function(slider, i) {
      if (slider.slideCount === 1 || slider.slideCount <= slider.options.slidesToShow) {
        return false;
      }
      return "<a class='slider-dots-item'></a>";
    },
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: '<div class="slider-control slider-control-prev"></div>',
    nextArrow: '<div class="slider-control slider-control-next"></div>',
    speed: 500,
    fade: false,
    autoplay: false,
    autoplaySpeed: 5000,
    useCSS: false,
    cssEase: 'linear',
    method: {},
    event: {
      init: function(event, slick) {
        self.slickInit = true;
        return self.$applyAsync();
      }
    },
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false
        }
      }
    ]
  };
}));
